var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6094 2.66684C16.6094 1.2656 15.3443 0 13.9427 0H3.27604C1.87444 0 0.609375 1.2656 0.609375 2.66684V13.3332C0.609375 14.7344 1.87444 16 3.27622 16H8.60938V9.95556H6.65382V7.28889H8.60938V6.24995C8.60938 4.45813 9.9548 2.84444 11.6094 2.84444H13.7649V5.51111H11.6094C11.3735 5.51111 11.0983 5.79751 11.0983 6.22649V7.28889H13.7649V9.95556H11.0983V16H13.9427C15.3443 16 16.6094 14.7344 16.6094 13.3332V2.66684Z",
    fill: "#CFCFCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.6c3f5d52cdd70727266609a8a55bf56a.svg";
export { ForwardRef as ReactComponent };